import React from 'react';
import { Accordion, Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import '../../../common/MobileGridCards.sass';

const FIXED_FIELD_NAMES = ['First Name', 'Last Name', 'Group', 'Speeding', 'High G-Force'];

const isEmptyValue = (value) => value === undefined || value === null || value.toString().trim() === '';
const displayValue = (value) => (isEmptyValue(value) ? 'N/A' : value);

const DriverEventBreakdownMobileCard = ({ row, columns = [] }) => {
	const { t } = useTranslation('translation', { keyPrefix: 'reportsPage.standardReportData' });

	const baseData = [
		{ label: t(('First Name').replace(/\s/g, '_')), value: row.first_name },
		{ label: t(('Last Name').replace(/\s/g, '_')), value: row.last_name },
		{ label: t('Group'), value: row.driver_group },
		{ label: t('Speeding'), value: row.HighSpeed || 0 },
		{ label: t(('High G-Force').replace(/\s/g, '_')), value: row.GSensor || 0 },
	];

	const additionalData = columns
		.filter((column) => !FIXED_FIELD_NAMES.includes(column.name))
		.map((column) => ({
			label: t(column.name.replace(/\s/g, '_')),
			value: row[column.dataField] || 0,
		}));

	return (
		<Card className={`mobile-grid-card ${additionalData.length ? 'mobile-accordion-card' : ''}`}>
			<Card.Body>
				<div className="mobile-card-header">
					<div className="mobile-card-info">
						{baseData.map(({ label, value }) => (
							<div className="mobile-card-info-row" key={label}>
								<span className="label">{label}:</span> <span className="value">{displayValue(value)}</span>
							</div>
						))}
					</div>
				</div>
				{!!additionalData.length && (
					<Accordion>
						<Accordion.Item eventKey="0">
							<Accordion.Header className="mobile-card-toggle" />
							<Accordion.Body>
								<div className="mobile-card-data">
									{additionalData.map(({ label, value }) => (
										<div className="mobile-card-data-item" key={label}>
											<span className="label">{label}:</span> <span className="value">{displayValue(value)}</span>
										</div>
									))}
								</div>
							</Accordion.Body>
						</Accordion.Item>
					</Accordion>
				)}
			</Card.Body>
		</Card>
	);
};

export default DriverEventBreakdownMobileCard;
